export function isDefined<T>(value: T | undefined): value is T {
  return value !== undefined;
}

export const isNotNull = <T>(value: T | null): value is T => value !== null;

export type DeepPartial<T> = {
  [P in keyof T]?: T[P] extends object ? DeepPartial<T[P]> : T[P];
};
